import { PageTemplateContent } from 'app/common/templates-next/page-template'
import ControlsBar from 'app/common/ui-next/controls-bar'
import { useDishesData } from 'app/dataProviders/dishes/DishesData'
import PlainButton from 'app/common/ui-next/plain-button'
import PlainIcon, { iconType, iconColor } from 'app/common/ui-next/plain-icon'

import { useDishesWithTechCard } from './useDishesWithTechCard'
import styles from './DishTechCardDownload.module.scss'

export const DishTechCardDownload = () => {
  const [{ dishes }] = useDishesData()

  const dishesWithTechCard = useDishesWithTechCard(dishes)
  const hasDishesWithTechCard = dishesWithTechCard.length > 0

  return (
    <PageTemplateContent
      animate
      skip={!hasDishesWithTechCard}
      borderBottom={hasDishesWithTechCard}
      skipPadding
    >
      <ControlsBar right className={styles.controls}>
        <PlainButton>
          {dishesWithTechCard.length === 1
            ? 'Скачать тех. карту'
            : `Скачать тех. карту (${dishesWithTechCard.length})`}
          &nbsp;
          <PlainIcon type={iconType.DOWNLOAD2} color={iconColor.COLOR_WHITE} />
        </PlainButton>
      </ControlsBar>
    </PageTemplateContent>
  )
}
